<template>
    <button @click="exportExcel">
        <slot></slot>
    </button>
</template>

<script>
import XLSX from 'xlsx/xlsx'

export default {
    name: 'export-excel-updated',

    props: {
        sheets: {
            type: Array,
            required: true
        },

        filename: {
            type: String,
            default: 'excel'
        },

        sheetname: {
            type: String,
            default: 'SheetName'
        }
    },
    data() {
        return {}
    },
    methods: {
        newSheet() {
            return [
                {
                    sheetname: '',
                    columns: [],
                    data: []
                }
            ]
        },

        exportExcel() {
            let vm = this

            let wb = XLSX.utils.book_new()

            vm.sheets.forEach((sheet, sheetIndex) => {
                let createXLSLFormatObj = []
                let newXlsHeader = []
                if (sheet.columns.length === 0) {
                    return
                }
                if (sheet.data.length === 0) {
                    return
                }
                sheet.columns.forEach((value, index) => {
                    if (value.visible == null || value.visible) {
                        newXlsHeader.push(value.title)
                    }
                })

                createXLSLFormatObj.push(newXlsHeader)
                sheet.data.forEach((row, index) => {
                    let innerRowData = []
                    sheet.columns.forEach((column, index) => {
                        if (column.visible == null || column.visible) {
                            innerRowData.push(this.getValueX(row, column))
                        }
                    })
                    createXLSLFormatObj.push(innerRowData)
                })

                let ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj)
                let ws_name = sheet.sheetname
                XLSX.utils.book_append_sheet(wb, ws, ws_name)
            })

            let filename = vm.filename + '.xlsx'

            XLSX.writeFile(wb, filename)
            this.$emit('completed')
        },
        getValueX(row, column) {
            var val = null
            if (!column.value) {
                val = row
            } else if (typeof column.value === 'string') {
                val = this.getValue(row, column.value)
            } else {
                val = column.value(row)
            }

            if (column.format) {
                return column.format(val)
            }
            return val
        },
        getValue(row, column) {
            if (row.hasOwnProperty(column)) {
                let val = row[column]
                if (val) {
                    return val
                }
            }

            if (column.includes('.')) {
                let split = column.split('.')

                let finalVal = row
                for (let i = 0; i < split.length; i++) {
                    if (finalVal) {
                        finalVal = finalVal[split[i]] || ''
                    }
                }
                return finalVal
            } else {
                if (row) {
                    return row[column]
                } else {
                    return ''
                }
            }
        }
    },
    created() {
        this.exportExcel()
    }
}
</script>
